export default "https://cdn-gra.amplement.io/statics/images/loader.gif";